import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import layoutContext from '../../layoutContext';

import './MiniCalcRange.scss';

const MiniCalcRange = ({
  setValue,
  value,
  min,
  max,
  step,
  id,
  name,
  units }) => {
  const { counter, setCounter } = useContext(layoutContext);
  return (
    <div className='mini-calc-part'>
      <div className='mini-calc-values'>
        <p className='mini-calc-name'>{name}:</p>
        <p className='mini-calc-name'><span>{value.toLocaleString('ru')}</span> {units}</p>
      </div>
      <input
        type='range'
        id={id}
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={e => setValue(+e.target.value)}
        onMouseDown={units === 'грн.' ?
          () => setCounter({
            summCount: counter.summCount + 1,
            daysCount: counter.daysCount
          }) :
          () => setCounter({
            summCount: counter.summCount,
            daysCount: counter.daysCount + 1
          })}
        className='mini-calc-range'
      />
    </div>
  );
};
export default MiniCalcRange;

MiniCalcRange.propTypes = {
  setValue: PropTypes.func,
  value: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  id: PropTypes.string,
  name: PropTypes.string,
  units: PropTypes.string,
};

